'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultRenderComponentList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getPageByQueryInfo = require('../../api/getPageByQueryInfo');

var _getPageByQueryInfo2 = _interopRequireDefault(_getPageByQueryInfo);

var _linkUtil = require('../../lib/linkUtil');

var _components = require('../../lib/components');

var _loadScript = require('../../lib/loadScript');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _values = require('../../lib/values');

var _LoadingScreenComponent = require('../../components/common/LoadingScreenComponent');

var _LoadingScreenComponent2 = _interopRequireDefault(_LoadingScreenComponent);

var _PageWrapper = require('../../components/common/PageWrapper');

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _fetch = require('../../lib/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _logger = require('../../lib/logger');

var logger = _interopRequireWildcard(_logger);

var _pageTypes = require('../../configs/pageTypes');

var pageTypes = _interopRequireWildcard(_pageTypes);

var _formatConfigsToComponentProps = require('../../lib/formatConfigsToComponentProps');

var _formatConfigsToComponentProps2 = _interopRequireDefault(_formatConfigsToComponentProps);

var _createPageAttrProps = require('../../lib/createPageAttrProps');

var _createPageAttrProps2 = _interopRequireDefault(_createPageAttrProps);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since 2017-05-16 20:04:18
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @author vivaxy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


var getPageData = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(context, fetch, getPageByQueryInfoURL) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!context.pageId) {
                            _context.next = 4;
                            break;
                        }

                        _context.next = 3;
                        return (0, _getPageByQueryInfo2.default)(fetch, getPageByQueryInfoURL, context.pageId);

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 4:
                        logger.error('URL parameter `pageId` is required');

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function getPageData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var defaultRenderComponentList = exports.defaultRenderComponentList = function defaultRenderComponentList(_ref2) {
    var componentList = _ref2.componentList,
        renderComponent = _ref2.renderComponent,
        pageAttrProps = _ref2.pageAttrProps;

    return componentList.map(function (component, index) {
        /**
         * 兼容两种数据格式
         *  - [ component ]
         *  - [ { component, type, children } ]
         */
        if (component.component) {
            return renderComponent(component.component, index, pageAttrProps);
        }
        return renderComponent(component, index, pageAttrProps);
    });
};

/**
 *
 * @param LoadingScreenComponent
 * @param fetch
 * @param mapStateToComponentProps
 * @param PageWrapper
 * @param pageDataAction
 * @param {String} getPageByQueryInfoURL 兼容美团地址：｀https://act-test.meituan.com/normal/page/queryInfo｀
 * @param {Function} renderComponentList 渲染组件列表的函数
 *                  接受的参数：
 *                      - componentList {Array}
 *                      - renderComponent {Function}
 *                      - pageAttrProps {Object}
 * @returns {IndexContainer}
 */

exports.default = function (_ref3) {
    var _ref3$LoadingScreenCo = _ref3.LoadingScreenComponent,
        LoadingScreenComponent = _ref3$LoadingScreenCo === undefined ? _LoadingScreenComponent2.default : _ref3$LoadingScreenCo,
        _ref3$fetch = _ref3.fetch,
        fetch = _ref3$fetch === undefined ? _fetch2.default : _ref3$fetch,
        _ref3$mapStateToCompo = _ref3.mapStateToComponentProps,
        mapStateToComponentProps = _ref3$mapStateToCompo === undefined ? _values.OOPS : _ref3$mapStateToCompo,
        _ref3$PageWrapper = _ref3.PageWrapper,
        PageWrapper = _ref3$PageWrapper === undefined ? _PageWrapper2.default : _ref3$PageWrapper,
        pageDataAction = _ref3.pageDataAction,
        _ref3$getPageByQueryI = _ref3.getPageByQueryInfoURL,
        getPageByQueryInfoURL = _ref3$getPageByQueryI === undefined ? '/normal/page/queryInfo' : _ref3$getPageByQueryI,
        _ref3$renderComponent = _ref3.renderComponentList,
        renderComponentList = _ref3$renderComponent === undefined ? defaultRenderComponentList : _ref3$renderComponent;


    var renderComponent = function renderComponent(component, index, pageAttrProps) {
        var componentPropsFromPreviousPage = typeof mapStateToComponentProps === 'function' ? mapStateToComponentProps() : {};
        var namespace = component.namespace,
            name = component.name,
            version = component.version,
            _component$props = component.props,
            componentProps = _component$props === undefined ? [] : _component$props;

        var props = _extends({}, (0, _formatConfigsToComponentProps2.default)(componentProps, 'value', pageTypes.LANDING_PAGE), {
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            pageType: pageTypes.LANDING_PAGE,
            pageAttr: pageAttrProps
        }, componentPropsFromPreviousPage);
        var Klass = (0, _components.getComponentFromComponentMap)(namespace, name, version).klass;
        return _react2.default.createElement(Klass, _extends({ key: index }, props));
    };

    return function (_Component) {
        _inherits(IndexContainer, _Component);

        function IndexContainer() {
            var _ref4;

            var _temp, _this, _ret;

            _classCallCheck(this, IndexContainer);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = IndexContainer.__proto__ || Object.getPrototypeOf(IndexContainer)).call.apply(_ref4, [this].concat(args))), _this), _this.state = { loading: true, data: [], pageAttr: [] }, _this.pageId = (0, _linkUtil.getParameterByName)(window.location.search, 'pageId'), _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(IndexContainer, [{
            key: 'componentDidMount',
            value: function () {
                var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
                    var data, pageAttr, pageRes, loadComponentScriptJobs;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    data = void 0, pageAttr = void 0, pageRes = void 0;
                                    _context2.prev = 1;

                                    if (!(pageDataAction && typeof pageDataAction === 'function')) {
                                        _context2.next = 9;
                                        break;
                                    }

                                    _context2.next = 5;
                                    return pageDataAction();

                                case 5:
                                    pageRes = _context2.sent;

                                    pageRes = (0, _getPageByQueryInfo.passData)(pageRes);
                                    _context2.next = 12;
                                    break;

                                case 9:
                                    _context2.next = 11;
                                    return getPageData(this, fetch, getPageByQueryInfoURL);

                                case 11:
                                    pageRes = _context2.sent;

                                case 12:

                                    data = pageRes.data;
                                    pageAttr = pageRes.pageAttr;
                                    _context2.next = 19;
                                    break;

                                case 16:
                                    _context2.prev = 16;
                                    _context2.t0 = _context2['catch'](1);

                                    logger.error('获取 pageData 出错', _context2.t0);

                                case 19:
                                    loadComponentScriptJobs = data.map(function (component) {
                                        var namespace = component.namespace,
                                            name = component.name,
                                            version = component.version,
                                            jsUrl = component.jsUrl;

                                        if (!jsUrl) {
                                            var error = new Error('Missing `jsUrl` in' + name);
                                            error.component = component;
                                            throw error;
                                        }
                                        return (0, _loadScript2.default)(jsUrl);
                                    });
                                    _context2.next = 22;
                                    return Promise.all(loadComponentScriptJobs);

                                case 22:
                                    // 先要 load 到脚本才能 setComponentMap
                                    data.forEach(function (component) {
                                        var namespace = component.namespace,
                                            name = component.name,
                                            version = component.version,
                                            props = component.props;
                                        // 这里 set 是为了下面的使用

                                        (0, _components.setComponentMap)(namespace, name, version, _extends({}, component, {
                                            klass: window[namespace][name][version].default,
                                            props: props
                                        }));
                                    });

                                    this.setState({ pageAttr: pageAttr, data: data, loading: false });

                                case 24:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this, [[1, 16]]);
                }));

                function componentDidMount() {
                    return _ref5.apply(this, arguments);
                }

                return componentDidMount;
            }()
        }, {
            key: 'render',
            value: function render() {
                var _state = this.state,
                    data = _state.data,
                    pageAttr = _state.pageAttr,
                    loading = _state.loading;

                var pageAttrProps = (0, _createPageAttrProps2.default)(pageAttr);

                return loading ? _react2.default.createElement(LoadingScreenComponent, null) : _react2.default.createElement(
                    PageWrapper,
                    pageAttrProps,
                    renderComponentList({ componentList: data, renderComponent: renderComponent, pageAttrProps: pageAttrProps })
                );
            }
        }]);

        return IndexContainer;
    }(_react.Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/containers/LandingPage/index.js
// module id = 220
// module chunks = 0